import { ApiSet, BaseResponse, IndexApiSet, useIndexApi, useShowApi } from 'utils/network/api_hooks'
import { CraifHttpClient } from '../utils/network/axios'
import { PagingResponse } from 'entities'
import { Freezer } from 'entities/freezer'

type FreezersResponse = PagingResponse & {
    results: Freezer[]
}

export function useFetchFreezersApi(): IndexApiSet<FreezersResponse> & {
    execute: () => void
} {
    const apiPath = 'freezers/'
    const api = useIndexApi<FreezersResponse>(new CraifHttpClient(), {
        initialResponse: { count: 0, results: [] },
    })

    const execute = (): void => {
        api.execute(apiPath)
    }

    return { ...api, execute: execute }
}

type FreezerResponse = BaseResponse & Freezer

export function useFetchFreezerApi(): ApiSet<FreezerResponse> & {
    execute: (id: number) => void
} {
    const api = useShowApi<FreezerResponse>(new CraifHttpClient(), {
        initialResponse: {},
    })

    const execute = (id: number): void => {
        const apiPath = `freezers/${id}/`
        api.execute(apiPath)
    }

    return { ...api, execute: execute }
}
